export default __webpack_public_path__ + "static/media/G0020.34I-25844_-15915_0.fa16fd74.jpg";